import dateformat from 'dateformat'
import { connect } from 'react-redux'

import { CONFIG } from 'shared/constants'
import { DiscountStatusIcon } from 'components/icons'
import {
  getArrivalDate,
  getEligibleForRegistryDiscount,
  getRegistryDiscountStartsAt,
  getRegistryDiscountUsed,
} from 'registry/reducers'

import SetupGoal from './setup-goal'

function getText(state, ownProps) {
  // Goal is complete when registry discount has been used.
  // We currently remove the registry discount goal when registry discount has been
  // used, so this tile will never be visible in a completed state.

  const isEligibleForRegistryDiscount = getEligibleForRegistryDiscount(state)
  if (isEligibleForRegistryDiscount) {
    return 'Your registry discount is available!'
  }

  const arrivalDate = getArrivalDate(state)
  if (!arrivalDate) {
    return `Get ${CONFIG.store.registryDiscountPctDisplay} off items in the Babylist shop!`
  }

  const discountDate = getRegistryDiscountStartsAt(state)
  const { isRegistryDiscountRevampEnabled } = ownProps
  if (isRegistryDiscountRevampEnabled) {
    return `Your registry discount will be available on ${dateformat(discountDate, 'UTC:mmm dS')}`
  }
  return `You'll get a ${
    CONFIG.store.registryDiscountPctDisplay
  } Babylist discount on ${dateformat(discountDate, 'UTC:mmm dS')}.`
}

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    icon: <DiscountStatusIcon />,
    text: getText(state, ownProps),
  }
}

export default connect(mapStateToProps)(SetupGoal)
